(function() {

    // Add the directive to the module
    angular.module("Sinewav3.Client.Shell")
        .directive(
            'siteInfo',
            [
                'CHROME',
                SiteInfoFactory
            ]
        );

    // Factory Method
    function SiteInfoFactory(CHROME)
    {
        // Construct and return the instance
        return {
            restrict: 'E',
            templateUrl: CHROME.PREFIX + CHROME.INFO + CHROME.POSTFIX
        };

    }
})();



